import { createEntityAdapter } from '@reduxjs/toolkit';
import { ClientManagerParams } from './clientManagers.types';

const adapter = createEntityAdapter<ClientManagerParams>();

export default adapter;
